import { ProgramNames } from '@/models/Program';
import { TextField, TextFieldProps } from '@mui/material';

interface SignupNamesProps extends Omit<TextFieldProps, 'onChange'> {
  value?: string | null;
  disabled?: boolean;
  helperText?: string;
  programId?: ProgramNames;
  required?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
  submitOnBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
}

const isRequiredField = (id: string, programId?: ProgramNames): boolean => {
  const requiredFieldIds = [
    'Address',
    'firstName',
    'lastName',
    'title',
    'streetAddress1',
    'city',
    'partnerName',
    'country',
    'zipCode',
  ];

  if (requiredFieldIds.includes(id)) return true;
  if (id.toLowerCase().includes('number')) return true;
  if (id.includes('Name')) return true;
  if (id.includes('shipping') && id !== 'shippingAddress2') return true;

  if (
    id.toLowerCase().includes('generic') &&
    programId != null &&
    [
      ProgramNames.TreeCitiesWorld,
      ProgramNames.TreeLineUSA,
      ProgramNames.TreeCampusHealthcare,
    ].includes(programId)
  ) {
    return true;
  }

  return false;
};

function SignUpNames({
  value = '',
  disabled,
  helperText,
  programId,
  required = false,
  onChange,
  submitOnBlur,
  ...props
}: SignupNamesProps) {
  const { id } = props;

  if (id == null) {
    throw new Error('id is required for SignUpNames component');
  }

  return (
    <TextField
      {...props}
      variant='outlined'
      disabled={disabled === true || id === 'email'}
      sx={{ flexGrow: 1 }}
      value={value}
      helperText={helperText}
      onBlur={submitOnBlur}
      onChange={onChange}
      required={required || isRequiredField(id, programId)}
    />
  );
}

export default SignUpNames;
